export default class RecenterControl{
    constructor(props){
        this.center = props.center;
    }
    onAdd(map){
        this._map = map;
        this._container = document.createElement("div");
        this._container.className = 'trimblemaps-ctrl trimblemaps-ctrl-group recenter';

        const control = document.createElement('button');
        control.className = 'trimblemaps-ctrl-icon icon-recenter';
        control.title="Recenter";
        control.ariaLabel="Recenter";
        control.textContent = '';
        control.addEventListener("click", ()=>{
            map.flyTo({
                center: this.center,
                speed: 0.5
            })
        });
        this._container.append(control);
        return this._container; 
    }

    setMapCenter(center){
        this.center = center;
    }
    
    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}